import { type JSX, type ReactNode } from 'react';

import { Page, StyleSheet, View } from '@react-pdf/renderer';

import { ReportPageHeader } from './ReportPageHeader';
import { PDF_COLORS, PDF_FONTS, PDF_PAGE, PDF_SPACING } from '../lib/pdfTokens';

type ReportPageProps = {
  children: ReactNode;
};

const styles = StyleSheet.create({
  page: {
    backgroundColor: PDF_COLORS.white,
    paddingTop: PDF_PAGE.marginTop + 14 + PDF_SPACING[6],
    paddingBottom: PDF_PAGE.marginBottom,
    paddingLeft: PDF_PAGE.marginLeft,
    paddingRight: PDF_PAGE.marginRight,
    fontFamily: PDF_FONTS.sans,
  },
  content: {
    flexGrow: 1,
    gap: PDF_SPACING[2],
  },
});

export function ReportPage({ children }: ReportPageProps): JSX.Element {
  return (
    <Page
      size='A4'
      style={styles.page}>
      <ReportPageHeader />
      <View style={styles.content}>{children}</View>
    </Page>
  );
}
